import I from '../types.ts';

const setMenuState: I['setMenuState'] = function ({ scrollTop }) {
    if (this.checkSmallMenu(scrollTop) && !this.state.isScrollActive) {
        this.setState({ isScrollActive: true });
    }

    if (!this.checkSmallMenu(scrollTop) && this.state.isScrollActive) {
        this.setState({ isScrollActive: false });
    }

    document.dispatchEvent(
        new CustomEvent('publicPageScroll', {
            detail: { scrollTop, isSmallMenu: this.checkSmallMenu(scrollTop) },
        }),
    );
};

export default setMenuState;
